import React from 'react';
import { History, Layers, ShieldAlert, MessageSquare, Brain, FolderKanban, BookOpen, Plug, Repeat } from 'lucide-react';

export type SideSection = 'chat' | 'projects' | 'routines' | 'rounds' | 'artifacts' | 'approvals' | 'memory' | 'skills' | 'connectors';

interface Props {
  active: SideSection;
  onChange: (s: SideSection) => void;
  approvalsCount: number;
  artifactsCount: number;
}

const ITEMS: Array<{ id: SideSection; label: string; Icon: React.ComponentType<{ className?: string }> }> = [
  { id: 'chat',       label: 'Chat',       Icon: MessageSquare },
  { id: 'projects',   label: 'Progetti',   Icon: FolderKanban },
  { id: 'routines',   label: 'Routine',    Icon: Repeat },
  { id: 'rounds',     label: 'Attività',   Icon: History },
  { id: 'artifacts',  label: 'Artefatti',  Icon: Layers },
  { id: 'approvals',  label: 'Conferme',   Icon: ShieldAlert },
  { id: 'memory',     label: 'Memoria',    Icon: Brain },
  // Task #3821 — Skills (procedure/playbook): confine skill ≠ memoria.
  { id: 'skills',     label: 'Skills',     Icon: BookOpen },
  // Task #3818 — Connettori: visibilità del perimetro effettivo + restrizione per-chat.
  { id: 'connectors', label: 'Connettori', Icon: Plug },
];

export const SideNav: React.FC<Props> = ({ active, onChange, approvalsCount, artifactsCount }) => (
  <nav className="w-12 shrink-0 border-r border-border bg-card flex flex-col items-center py-2 gap-1 overflow-y-auto">
    {ITEMS.map(item => {
      const Icon = item.Icon;
      const isActive = active === item.id;
      const badge = item.id === 'approvals' ? approvalsCount : item.id === 'artifacts' ? artifactsCount : 0;
      return (
        <button
          key={item.id}
          type="button"
          onClick={() => onChange(item.id)}
          title={item.label}
          className={`relative h-9 w-9 rounded-lg flex items-center justify-center transition ${
            isActive ? 'bg-violet-100 text-violet-700' : 'text-muted-foreground hover:bg-muted'
          }`}
        >
          <Icon className="h-4 w-4" />
          {badge > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-violet-600 text-white text-[10px] font-bold flex items-center justify-center">
              {badge > 9 ? '9+' : badge}
            </span>
          )}
        </button>
      );
    })}
  </nav>
);
